import { Component, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';
import { AccountService } from '../../auth/account.service';

@Component({
  selector: 'tel-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements AfterViewInit {
  constructor(private location: Location, private accountService: AccountService) {}

  ngAfterViewInit(): void {
    this.accountService.logout();
  }

  redirigeALogin(): void {
    // Esto es necesario para evitar que si se realiza login de nuevo redirija de vuelta a la pantalla de logout
    this.location.replaceState('');

    this.accountService.redirectToSSO();
  }
}
